export const APP_OPEN = 'App.Open';
export const APP_SESSION = 'App.Session'; // after meta response
export const APP_REC_REQ_SENT = 'App.RecReqSent';
export const APP_REC_REQ_DONE = 'App.RecReqDone';
export const ACCOUNT_PERMISSION_PROMPT = 'Account.PermissionPrompt';
export const ACCOUNT_PERMISSION_GRANT = 'Account.PermissionGrant';

// Session
export const SESSION_NEW = 'Session.New';

/**
 * Auth events
 * https://gotinder.atlassian.net/wiki/x/opiqAQ
 */

// Intro Screen
export const ACCOUNT_INTRO = 'Account.Intro';
export const ACCOUNT_TERMS_OF_SERVICE = 'Account.TermsOfService';
export const ACCOUNT_PRIVACY_POLICY = 'Account.PrivacyPolicy';
export const ACCOUNT_COOKIE_POLICY = 'Account.CookiesPolicy';
export const ACCOUNT_DELETE = 'Account.Delete';
// export const ACCOUNT_FACEBOOK_POLICY = 'Account.FacebookPolicy';

// Consent
export const ACCOUNT_CONSENT = 'Account.Consent';

// Auth
export const AUTH_START = 'Auth.Start';
export const AUTH_SUCCESS = 'Auth.Success';
export const LOGIN_SUCCESS = 'Login.Success';
export const OAUTH_PRESENT_UI = 'OAuth.PresentUI';
export const OAUTH_SUCCESS = 'OAuth.Success';
export const OAUTH_ERROR = 'OAuth.Error';
export const AUTH_AGE_GATE = 'Auth.AgeGate';
export const IDENTITY_MFA = 'Identity.MFA'; // MFA = multifactor authentication
export const IDENTITY_INTERACT = 'Identity.Interact';
export const EXPERIENCES_INTERACT = 'Experiences.Interact';
export const MEMBERSHIP_INTERACT = 'Membership.Interact';

// Account Recovery
export const AUTH_RECOVER_ACCOUNT = 'Auth.RecoverAccount';

// SMS
// https://gotinder.atlassian.net/wiki/x/o_7VAQ#TinderAuth-ClientQuickfireEventsforNewSMSFlow
export const AUTH_VERIFY_SMS = 'Auth.VerifySMS';

// Device tracking
export const AUTH_CHECK_DEVICE = 'Auth.CheckDevice';

// Captcha
export const CAPTCHA_START_CHALLENGE = 'WebSignup.BeforeChallenge';
export const CAPTCHA_CHALLENGE_RESULT = 'WebSignup.AfterChallenge';
export const TRUST_CHALLENGE = 'Trust.Challenge'; // TODO - deprecated in etl_schemas

// Autorenew
export const AUTORENEW_VIEW = 'Autorenew.View';
export const AUTORENEW_UPDATE = 'Autorenew.Update';

export const LOGOUT_START = 'Logout.Start';
export const LOGOUT_SUCCESS = 'Logout.Success';
export const LOGOUT_ERROR = 'Logout.Error';

export const MATCH_LIST = 'Match.List';

export const CHAT_SEND_MESSAGE = 'Chat.SendMessage';

// InstaMessage
export const NEW_MATCH_PAGE_VIEW = 'NewMatch.PageView';
export const NEW_MATCH_PAGE_ACTION = 'NewMatch.PageAction';

export const CHAT_OPEN_PROFILE = 'Chat.OpenProfile'; // TODO - on deprecation list

export const FEEDBACK_USER = 'Feedback.User';

// When a non-T+ or T+ user tries to superlike
export const SUPERLIKE_ROADBLOCK_VIEW = 'SuperLikeRoadblock.View';

// export const TINDERWEB_PURCHASE_VIEW = 'TinderWebPurchase.View'; // User enters the checkout flow
// User submits the purchase request on the checkout page
// export const TINDERWEB_PURCHASE_COMPLETE = 'TinderWebPurchase.Complete';
// export const TINDERWEB_PURCHASE_PROCESS = 'TinderWebPurchase.Process'; // User exits the checkout page
// export const TINDERWEB_PURCHASE_FIELD_ERROR = 'TinderWebPurchase.FieldError';

export const TINDERWEB_3D_PURCHASE_VIEW = 'TinderWebPurchase.3DView'; // TODO: not found in etl_schemas
export const TINDERWEB_3D_PURCHASE_COMPLETE = 'TinderWebPurchase.3DComplete'; // TODO: not found in etl_schemas

export const POSTMATCH_INTERACT = 'Postmatch.Interact';
export const PUSH_PERMISSION_PROMPT = 'Push.PermissionPrompt';
// export const PUSH_RECEIVE = 'Push.Receive';

export const PASSPORT_MAP_MOVE = 'Passport.MapMove';
export const PASSPORT_MAP_OPEN = 'Passport.MapOpen';
export const PASSPORT_MAP_PIN_DROP = 'Passport.MapPinDrop';
export const PASSPORT_MAP_SEARCH_SELECT = 'Passport.MapSearchSelect';
export const PASSPORT_MENU_CHOOSE_LOCATION = 'Passport.MenuChooseLocation';
export const PASSPORT_MENU_OPEN = 'Passport.MenuOpen';
export const PASSPORT_MENU_CLOSE = 'Passport.MenuClose';
export const PASSPORT_MENU_MY_LOCATION = 'Passport.MenuMyLocation';
export const PASSPORT_PIN_SELECT = 'Passport.PinSelect';

export const TRIGGER_RECEIVE = 'Trigger.Receive';
export const UPDATES_RECEIVED = 'Updates.Received';
export const WEBSOCKET_CONNECT = 'Websocket.Connect';
export const WEBSOCKET_CLOSE = 'Websocket.Close';
export const WEBSOCKET_NUDGE_RECEIVED = 'Websocket.NudgeReceived';

export const ONBOARDING_ERROR = 'Onboarding.Error';
export const ONBOARDING_EVENT = 'Onboarding.Event';

export const BOOST_START = 'Boost.Start';
export const BOOST_END = 'Boost.End';
export const BOOST_PROGRESS_VIEW = 'Boost.ProgressView';
export const BOOST_VIEW_RESULT = 'Boost.ViewResult';
export const BOOST_TUTORIAL_VIEW = 'BoostTutorial.View';

export const LIKES_YOU_LIST = 'LikesYou.List'; // Likes you page

export const SUPERLIKE_INTERACT = 'SuperLike.Interact';

export const TINDER_PLUS_RESTORE = 'TinderPlus.Restore'; // user restores a TinderPlus purchase from within the app/webpage

export const INTRO_PRICE_START = 'IntroPricing.Start'; // User views the intro price modal for the first time
export const INTRO_PRICE_BANNER_VIEW = 'IntroPricing.BannerReminderView'; // user sees the reminder banner

export const REVENUE_INTERACT = 'Revenue.Interact'; // New event for paywall actions
export const REVENUE_PURCHASE_FLOW = 'Revenue.PurchaseFlow'; // New event for paywall actions

// export const TERMS_VIEWED = 'Terms.ViewTermsUpdate';
// export const TERMS_ACCEPTED = 'Terms.AcceptTermsUpdate';
// export const TERMS_LINK_CLICKED = 'Terms.ClickTermsLink';

export const VERIFY_EMAIL_EVENT = 'Auth.VerifyEmail';

// Incentives
export const PROMO_CODE_ENTER = 'PromoCode.Enter';
export const PROMO_CODE_RESPONSE = 'PromoCode.Response';

// Performance
export const CLIENT_PERFORMANCE = 'Client.PerfEvent';

// A user navigates via toggle
export const SESSION_NAVIGATE = 'Session.Navigate';

// Sub Merchandising Page
export const MERCHANDISING_PAGE_VIEW = 'MerchandisingPage.View';
export const CONTROLLA_INTERACT = 'Controlla.Interact';

export const LEGACY_AUTH_START_LOCATION_LOGIN_BUTTON = 1;
export const LEGACY_AUTH_START_LOCATION_REAUTH = 3;

// Settings
export const SETTINGS_INTERACT = 'Settings.Interact';

// User
export const USER = 'User';
